// React
import React, { Component } from 'react';

class DownloadLink extends Component {
  constructor(props) {
    super(props);

    this.ref = React.createRef();
    this.state = {random: 0};

    this.didUpdateState = this.didUpdateState.bind(this);
  }

  componentDidMount() {
    if(typeof window.jQuery !== 'undefined') {
      window.jQuery(this.ref.current).popover();
    }

	  window.addEventListener('pushState', this.didUpdateState);
  }

  componentWillUnmount() {
  	window.removeEventListener('pushState', this.didUpdateState);
  }

	didUpdateState() {
		this.setState({random: Math.random() * 100000})
	}

	render() {
    const { url, userIsAnonymous } = this.props;

		const current = '?current=' + encodeURIComponent(window.location.pathname + window.location.search);

		if ((url === "") || (typeof(url) === "undefined")) return (null);

    if(userIsAnonymous && typeof url !== 'undefined') {
      const message = window.Drupal.t('To access this feature, please <a href="/user/login!current" target="_blank">login</a> or <a href="/user/register!current" target="_blank">register</a> as a guest.', {'!current': current});
      return (
        <a tabIndex="0" role="button" ref={this.ref} className="btn product-download-link requires-login" data-container="body" data-toggle="popover" data-trigger="focus" data-html="true" data-placement="top" data-content={message}><span className="icon-ti-download"/></a>
      )
    }

    return(
      <a className="product-download-link" href={url} target="_blank" rel="noopener noreferrer"><span className="icon-ti-download"/></a>
    )
  }
}

export default DownloadLink;
